import { mapPageTestIDs } from '@constants';

export const PAGE_CHILD_IDS = [
  mapPageTestIDs.changeMapOverlayTypeRadarButton,
  mapPageTestIDs.changeMapOverlayTypeFutureRadarButton,
  mapPageTestIDs.changeMapOverlayTypeLightningButton,
  mapPageTestIDs.changeMapOverlayTypeAlertsButton,
  mapPageTestIDs.changeMapOverlayTypeSatelliteButton,
  mapPageTestIDs.changeMapOverlayTypeTemperatureButton,
  mapPageTestIDs.changeMapOverlayTypeFeelsLikeButton,
  mapPageTestIDs.changeMapOverlayTypeWindButton,
  mapPageTestIDs.changeMapOverlayTypeBreathingIndexButton,
  mapPageTestIDs.changeMapZoomLocalButton,
  mapPageTestIDs.changeMapZoomRegionalButton,
  mapPageTestIDs.changeMapZoomNationalButton,
  mapPageTestIDs.changeMapPageViewMapButton,
];
